import React, { useEffect, useState } from 'react'
import style from './createProject.module.scss'
import { useActions } from '../../starter/hooks/actions'
import { useAppSelector } from '../../starter/hooks/redux'
import dayjs, { Dayjs } from 'dayjs'
import { DatePicker, Input, Select } from 'antd'
import { IAntSelectOption, ITmpProject } from '../../starter/model/interfaces'
import TextArea from 'antd/es/input/TextArea'
import validator from 'validator'

export default function CreateProject() {
  const { setTmpProject } = useActions()
  const { project, apiError } = useAppSelector((state) => state.tmp)

  const { projectManagers } = useAppSelector((state) => state.projectManagers)
  const { employees } = useAppSelector((state) => state.employees)

  const [projectManagerOptions, setProjectManagerOptions] = useState<IAntSelectOption[]>([])
  const [employeesOptions, setEmployeesOptions] = useState<IAntSelectOption[]>([])
  const [formErrors, setFormErrors] = useState({ title: '', code: '', from: '', to: '' })

  useEffect(() => {
    setProjectManagerOptions(
      projectManagers.map((p) => ({
        value: p._id,
        label: `${p.firstName} ${p.lastName}`
      }))
    )
  }, [projectManagers])

  useEffect(() => {
    setEmployeesOptions(
      employees.map((p) => ({
        value: p._id,
        label: `${p.firstName} ${p.lastName}`
      }))
    )
  }, [projectManagers, employees])

  const handleInputChange = (evt: any): void => {
    if (evt.target) {
      const { name, value } = evt.target
      const _tmpProject = projectValidate({
        ...project,
        [name]: value
      })
      setTmpProject(_tmpProject)
    }
  }
  const handleInputChangeDate = (name: string, date: Dayjs, dateString: string | string[]): void => {
    const tmpProject = projectValidate({
      ...project,
      [name]: date && date.toDate()
    })
    setTmpProject(tmpProject)
  }

  const handlerOnSelectSelector = (name: string, source: any[], value: string, option: IAntSelectOption) => {
    const tmpProject = projectValidate({
      ...project,
      [name]: { ...source.find((item) => item._id === value) }
    })
    setTmpProject(tmpProject)
  }

  const projectValidate = (project: ITmpProject): ITmpProject => {
    let isValid = true
    let errors: any = {}
    Object.keys(project).forEach((key) => {
      switch (key) {
        case 'title':
          if (project[key].length < 2) {
            isValid = false
            errors[key] = 'Название проекта должно содержать не менее двух символов'
          } else if (!validator.matches(project[key], /^[0-9-A-Za-zА-Яа-яЁё\s-]{2,30}$/)) {
            isValid = false
            errors[key] = 'Название проекта должно содержать только латиницу, кириллицу, пробел, дефис или цифры'
          }
          break
        case 'code':
          if (project[key].length < 2) {
            isValid = false
            errors[key] = 'Код проекта должен содержать не менее двух символов'
          } else if (!validator.matches(project[key], /^[0-9-A-Za-zА-Яа-яЁё\s-_]{2,30}$/)) {
            isValid = false
            errors[key] =
              'код проекта должен содержать только латиницу, кириллицу, пробел, дефис, знак подчеркивания или цифры'
          }
          break
        case 'from':
          if (!project[key]) {
            isValid = false
            errors[key] = 'Заполните дату начала проекта'
          }
          break
        case 'to':
          if (!project[key]) {
            isValid = false
            errors[key] = 'Заполните дату окончания проекта'
          }
          break
        default:
          break
      }
    })
    setFormErrors(errors)
    return {
      ...project,
      validate: {
        isValid,
        message: Object.keys(errors).map((key) => errors[key]),
        showError: project.validate?.showError || false
      }
    }
  }

  return (
    <div className={style.wrapper}>
      <label className={style.inputLabel}>
        Название проекта
        <Input
          className={style.input}
          name='title'
          placeholder='Название проекта'
          value={project.title}
          onChange={handleInputChange}
        />
        {formErrors.title && project.validate.showError && (
          <div className={`${formErrors.title ? style.inputError : ''}`}>{formErrors.title}</div>
        )}
      </label>
      <label className={style.inputLabel}>
        Код проекта
        <Input
          className={style.input}
          name='code'
          placeholder='Код проекта'
          value={project.code}
          onChange={handleInputChange}
        />
        {formErrors.code && project.validate.showError && (
          <div className={`${formErrors.code ? style.inputError : ''}`}>{formErrors.code}</div>
        )}
      </label>
      <label className={style.inputLabel}>
        начало проекта
        <br />
        <DatePicker
          style={{ margin: '0.5rem 0' }}
          name='from'
          value={project.from && dayjs(project.from)}
          onChange={(date, dateString) => {
            handleInputChangeDate('from', date, dateString)
          }}
        />
        {formErrors.from && project.validate.showError && (
          <div className={`${formErrors.from ? style.inputError : ''}`}>{formErrors.from}</div>
        )}
      </label>
      <br />
      <label className={style.inputLabel}>
        Окончание проекта
        <br />
        <DatePicker
          style={{ margin: '0.5rem 0' }}
          name='birthDay'
          value={project.to && dayjs(project.to)}
          onChange={(date, dateString) => {
            handleInputChangeDate('to', date, dateString)
          }}
        />
        {formErrors.to && project.validate.showError && (
          <div className={`${formErrors.to ? style.inputError : ''}`}>{formErrors.to}</div>
        )}
      </label>
      <br />
      <label className={style.inputLabel}>
        Менеджер проекта
        <br />
        <Select
          showSearch
          // style={{ width: 200 }}
          value={project.manager?._id}
          placeholder='Выберите менеджера проекта'
          optionFilterProp='label'
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
          }
          options={projectManagerOptions}
          onSelect={(value: string, option: IAntSelectOption) => {
            handlerOnSelectSelector('manager', projectManagers, value, option)
          }}
        />
      </label>
      <br />
      <label className={style.inputLabel}>
        Ответственный сотрудник
        <br />
        <Select
          showSearch
          // style={{ width: 200 }}
          value={project.responsibleEmployee?._id}
          placeholder='Выберите отвественного сотрудника'
          optionFilterProp='label'
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
          }
          options={employeesOptions}
          onSelect={(value: string, option: IAntSelectOption) => {
            handlerOnSelectSelector('responsibleEmployee', employees, value, option)
          }}
        />
      </label>
      <br />
      <label className={style.inputLabel}>
        Комментарий
        <TextArea rows={4} value={project.comment} name='comment' onChange={handleInputChange} />
      </label>
      {apiError.isError && (
        <p className={style.errorMessage}>
          {typeof apiError.message === 'object' ? JSON.stringify(apiError.message) : apiError.message}
        </p>
      )}
    </div>
  )
}
